import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, catchError } from 'rxjs';
import { HelperService } from '../helper.service';
import { PageModel } from '../models/page-model';
import {BaseService} from "./base.service";
import { SeasonModel } from '../models/season-model';
import { CreateSeasonModel } from '../models/create-season-model';
import { SeasonFarmFieldModel } from '../models/season-farm-field-model';
import { SeasonDetailsModel } from '../models/season-details-model';
import { SeasonMetaDataCombinedModel } from '../models/season-models/season-meta-data-combined-model';
import { SeasonFarmsModel } from '../models/season-models/season-farms-model';
import { SeasonFieldBaseDto } from '../dto/season-dto/season-field-base-dto';
import { FieldAdminSeasonFieldsModel } from '../models/season-models/field-admin-season-fields-model';
import { SeasonFullModel } from '../models/season-models/season-full-model';
import { SeasonFieldVegatablesDto } from '../dto/season-dto/season-field-vegetables-dto';
import { SeasonFieldFruitDto } from '../dto/season-dto/season-field-fruit-dto';
import { SeasonFieldVineyardDto } from '../dto/season-dto/season-field-vineyard-dto';
import { SeasonFieldGrainFeedDto } from '../dto/season-dto/season-field-grain-feed-dto';
import { SeasonDetailFieldModel } from '../models/season-models/season-detail-field-model';
import { FieldAdminSeasonFarmFilterModel } from '../models/season-models/field-admin-season-farm-filter-model';
import { ExstraDetailModel } from '../models/season-models/exstra-detail-model';
import {SeasonFieldBase} from "../dto/season-dto/season-field-base";
import {SeasonDropdownModel} from "../models/season-models/season-dropdown-model";

@Injectable({
  providedIn: 'root'
})
export class SeasonManagerService extends BaseService {

private API_SEASON_MANAGEMENT_URL = this.API_BASE_URLv4 + "season-management";

  constructor(
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
      public helper: HelperService,
  ) {
    super();
  }


  /// GET ///
  getAllPaginatedSeasonsListByTenantId(tenantId:number, page: number, size: number,searchQuery?:string, fromDate?:string, toDate?: string, seasonStatusId?: number): Observable<PageModel<SeasonModel[]>> {

    let params = new HttpParams()
        .set('page', page.toString())
        .append('size', size.toString())

     if (tenantId) {
          params = params.append('tenantId', tenantId.toString());
      }

    if (searchQuery) {
        params = params.append('searchQuery', searchQuery);
    }

    if (fromDate) {
        params = params.append('fromDate', fromDate);
    }

    if (toDate) {
        params = params.append('toDate', toDate);
    }

    if (seasonStatusId) {
        params = params.append('seasonStatusId', seasonStatusId);
    }

    return this.httpClient.get<PageModel<SeasonModel[]>>(this.API_SEASON_MANAGEMENT_URL +`/season/batch/seasons`, {params})
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Seasons List','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}



getSeasonFarmsAndFields(tenantId:number, fromDate:string, toDate:string, seasonId?:number): Observable<SeasonFarmFieldModel[]> {

    let params = new HttpParams()

    if (fromDate) {
        params = params.append('fromDate', fromDate.toString());
    }

    if (toDate) {
        params = params.append('toDate', toDate.toString());
    }

 if (seasonId) {
      params = params.append('seasonId', seasonId.toString());
  }


  return this.httpClient.get<SeasonFarmFieldModel[]>(this.API_SEASON_MANAGEMENT_URL +`/season/create?tenantId=${tenantId}`,{params})
      .pipe(
          catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Seasons List','close', {
                  duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
          })
      );
}


  //Get Season Meta Data all dropdowns

getSeasonMetaData(): Observable<SeasonMetaDataCombinedModel> {

    return this.httpClient.get<SeasonMetaDataCombinedModel>(this.API_SEASON_MANAGEMENT_URL +`/meta/all`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Meta Data','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }
  

  //Get Season By Id Details

getSeasonFarmsById(seasonId:number): Observable<SeasonDetailsModel> {

    return this.httpClient.get<SeasonDetailsModel>(this.API_SEASON_MANAGEMENT_URL +`/season/${seasonId}/details`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Details','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }

  getDetailsOfFieldById(seasonId:number): Observable<SeasonDetailFieldModel> {

    return this.httpClient.get<SeasonDetailFieldModel>(this.API_SEASON_MANAGEMENT_URL +`/detail/field/${seasonId}`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Details','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }

  // Get Season By Id Farms
  /**
   * The Crop Nutrition Plan field order for a season, as field ids, best first.
   *
   * **Only fields that were given a position come back.** The caller already knows which fields
   * the season holds, so a partial list is honest about only part of an order being set. The rest
   * belong at the end, alphabetically, which is what the Field Order tab does with them.
   */
  getFieldOrder(seasonId: number): Observable<number[]> {
    return this.httpClient.get<number[]>(this.API_SEASON_MANAGEMENT_URL + `/season/${seasonId}/field-order`);
  }

  /**
   * Saves the field order for a season.
   *
   * **Send the sequence, not positions.** The server numbers 1..n from this list, so a gap or a
   * duplicate cannot be introduced from here. An empty array clears the order, which is the reset
   * to default.
   */
  saveFieldOrder(seasonId: number, fieldIds: number[]): Observable<void> {
    return this.httpClient.put<void>(
      this.API_SEASON_MANAGEMENT_URL + `/season/${seasonId}/field-order`, { fieldIds });
  }

  getSeasonById(seasonId:number, expand?: boolean): Observable<SeasonFarmsModel[]> {
    const params = expand ? '?expand=true' : '';
    return this.httpClient.get<SeasonFarmsModel[]>(this.API_SEASON_MANAGEMENT_URL +`/season/${seasonId}${params}`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }

  getSeasonFarmFilter(tenantId:number): Observable<FieldAdminSeasonFarmFilterModel[]> {

    return this.httpClient.get<FieldAdminSeasonFarmFilterModel[]>(this.API_SEASON_MANAGEMENT_URL +`/season/farmfilter?tenantId=${tenantId}`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Meta Data','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }


  getSeasonsListForDropDown(tenantId:number): Observable<SeasonDropdownModel[]> {

    return this.httpClient.get<SeasonDropdownModel[]>(this.API_SEASON_MANAGEMENT_URL +`/season/list?tenantId=${tenantId}`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Meta Data','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }


  getPaginatedFieldAdminFields(tenantId:number, page?: number, size?: number, date?: string, farmId?:number, searchQuery?:string, isActiveSeason?:boolean): Observable<PageModel<FieldAdminSeasonFieldsModel[]>> {

    let params = new HttpParams()
    .set('page', page.toString())
    .append('size', size.toString())

//  if (tenantId) {
//       params = params.append('tenantId', tenantId.toString());
//   }

if (date) {
    params = params.append('date', date);
}

if (farmId) {
    params = params.append('farmId', farmId);
}
if (searchQuery) {
    params = params.append('searchQuery', searchQuery);
}

if (isActiveSeason !== null && isActiveSeason !== undefined) {
    params = params.append('isActiveSeason', isActiveSeason);
}

    return this.httpClient.get<PageModel<FieldAdminSeasonFieldsModel[]>>(this.API_SEASON_MANAGEMENT_URL +`/season/batch/fields?tenantId=${tenantId}`,{params})
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Fields List','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }

  // convertDataForBE(seasonFormData: SeasonFieldBase): SeasonFieldBaseDto {
  //     let fieldDetails: SeasonFieldBaseDto = {
  //         id: seasonFormData.id,
  //         fieldId: seasonFormData.fieldId,
  //         fieldTypeId: seasonFormData.fieldType,
  //         fieldName: seasonFormData.fieldName,
  //         allowNotifications: seasonFormData.allowNotifications,
  //         plantDate: seasonFormData.plantDate,
  //         currentCropId: seasonFormData.currentCrop,
  //         cultivar: seasonFormData.cultivar,
  //         isHarvested: seasonFormData.isHarvested,
  //         yieldAverage: Number(seasonFormData.yieldAverage),
  //         yieldGoal: Number(seasonFormData.yieldGoal),
  //         isIrrigation: seasonFormData.isIrrigation,
  //         expectedWaterAmount: Number(seasonFormData.expectedWaterAmount),
  //         irrigationTypeId: seasonFormData.irrigationType,
  //         grainFeed: {
  //             previousCropId: seasonFormData.grainFeed.previousCrop,
  //             tillageId: seasonFormData.grainFeed.tillage,
  //             bearing: seasonFormData.grainFeed.bearing,
  //             podEffectivenessId: seasonFormData.grainFeed.podEffectiveness,
  //             harvestResiduesId: seasonFormData.grainFeed.harvestResidues,
  //             plantId: seasonFormData.grainFeed.plantSpread,
  //             plantActionId: seasonFormData.grainFeed.plantAction,
  //             trackWidth: seasonFormData.grainFeed.trackWidth,
  //             fertilizerPlacementId: seasonFormData.grainFeed.fertilizerPlacement,
  //             plantFertilizerTypeId: seasonFormData.grainFeed.plantFertilizerType,
  //             topDressingMethodId: seasonFormData.grainFeed.topDressingMethod,
  //             typeOfFertilizerBob1Id: seasonFormData.grainFeed.typeOfFertilizerBob1,
  //             typeOfFertilizerBob2Id: seasonFormData.grainFeed.typeOfFertilizerBob2
  //         },
  //         vegetables: {
  //             fertilizerTypeId: seasonFormData.vegetables.fertilizerType,
  //             previousCropId: seasonFormData.vegetables.previousCrop,
  //             tillageId: seasonFormData.vegetables.tillage,
  //             harvestResiduesId: seasonFormData.vegetables.harvestResidues,
  //             plantActionId: seasonFormData.vegetables.plantAction,
  //             plantDensity: seasonFormData.vegetables.plantDensity,
  //             fertilizerPlacementWithPlantingId: seasonFormData.vegetables.fertilizerPlacementWithPlanting,
  //             methodOfTopDressingId: seasonFormData.vegetables.methodOfTopDressing,
  //             typeOfTopDressingFertilizerId: seasonFormData.vegetables.typeOfTopDressingFertilizer,
  //             waterQualityEcId: seasonFormData.vegetables.waterQualityEc,
  //             timeLimeApplied: seasonFormData.vegetables.timeLimeApplied,
  //             thaLimeApplied: seasonFormData.vegetables.thaLimeApplied
  //         },
  //         vineyard: {
  //             cropId: seasonFormData.vineyard.cropCode,
  //             growthPower: seasonFormData.vineyard.growthPower,
  //             fertilizerTypeId: seasonFormData.vineyard.fertilizerType,
  //             plantYear: seasonFormData.vineyard.plantYear
  //         },
  //         fruit: {
  //             cropId: seasonFormData.fruit.cropCode,
  //             growthPower: seasonFormData.fruit.growthPower,
  //             fertilizerTypeId: seasonFormData.fruit.fertilizerType,
  //             plantYear: seasonFormData.fruit.plantYear
  //         }
  //     };
  //
  //     return fieldDetails;
  // }


  convertDataForFE(seasonFormData: SeasonFieldBaseDto): SeasonFieldBase {
      let fieldDetails: SeasonFieldBase = {
          id: seasonFormData.id,
          fieldId: seasonFormData.fieldId,
          fieldType: seasonFormData.fieldTypeId,
          fieldName: seasonFormData.fieldName,
          allowNotifications: seasonFormData.allowNotifications,
          plantDate: seasonFormData.plantDate,
          currentCrop: seasonFormData.currentCropId,
          cultivar: seasonFormData.cultivar,
          isHarvested: seasonFormData.isHarvested,
          yieldAverage: Number(seasonFormData.yieldAverage),
          yieldGoal: Number(seasonFormData.yieldGoal),
          isIrrigation: seasonFormData.isIrrigation,
          expectedWaterAmount: Number(seasonFormData.expectedWaterAmount),
          irrigationType: seasonFormData.irrigationTypeId,
          grainFeed: seasonFormData.grainFeed,
          vegetables: seasonFormData.vegetables,
          vineyard: seasonFormData.vineyard,
          fruit: seasonFormData.fruit
      };

      return fieldDetails;
  }


  //detail  & Extra Details 
  
getSeasonDetailExtraData(detailId:number, fieldTypeId: number): Observable<ExstraDetailModel> {

    return this.httpClient.get<ExstraDetailModel>(this.API_SEASON_MANAGEMENT_URL +`/detail/${detailId}/fieldType/${fieldTypeId}`)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving Season Field Extra Details','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }



    //POST
    postNewSeasonDetails(fieldId: number, seasonId: number): Observable<any> {
        const seasonDetailsBody = {
            fieldId: fieldId,
            seasonId: seasonId
        }
        
        return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL + '/detail',seasonDetailsBody)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Season Detail','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    postNewSeason(description: string, fromDate: string, toDate: string, note:string, tenantId:number): Observable<CreateSeasonModel> {
        const seasonBody = {
            description: description,
            startDate: fromDate,
            endDate: toDate,
            note: note,
            tenantId: tenantId
        }
        
        return this.httpClient.post<CreateSeasonModel>(this.API_SEASON_MANAGEMENT_URL + '/season',seasonBody)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Season','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
    



    
  postSeasonDetailsVegetables(fieldTypeId:number,seasonDetails:SeasonFieldVegatablesDto): Observable<any> {

    return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/${fieldTypeId}/vegetables`, seasonDetails)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error posting Season Details Vegetables','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}

postSeasonDetailsGrainFeed(fieldTypeId:number,seasonDetails:SeasonFieldGrainFeedDto): Observable<any> {

    return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/${fieldTypeId}/grainfeed`, seasonDetails)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error posting Season Details Grain Feed','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}

postSeasonDetailsFruit(fieldTypeId:number,seasonDetails:SeasonFieldFruitDto): Observable<any> {

    return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/${fieldTypeId}/fruit`, seasonDetails)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error posting Season Details Fruit','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}

postSeasonDetailsVineyard(fieldTypeId:number,seasonDetails:SeasonFieldVineyardDto): Observable<any> {

    return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/${fieldTypeId}/vineyard`, seasonDetails)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error posting Season Details Vineyard','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}






    /// PUT ///
    updateEndSeasonById(id: number): Observable<any> {
      const body = { };
      return this.httpClient.put<any>(this.API_SEASON_MANAGEMENT_URL +`/season/${id}/end`, body)
          .pipe(
              catchError((err) => {
                  this.hasError.next(true);
                  this.snackBar.open('Error Ending Season','close', {
                      duration: 5000,
                  });
                  this.hasError.next(false);
                  return this.errorHandler(err);
              })
          );
  }


  updateSeason(description: string, fromDate: string, toDate: string, note:string, seasonId:number): Observable<CreateSeasonModel> {
    const seasonBody = {
        description: description,
        startDate: fromDate,
        endDate: toDate,
        note: note
    }
    
    return this.httpClient.put<CreateSeasonModel>(this.API_SEASON_MANAGEMENT_URL + `/season/${seasonId}`,seasonBody)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Updating Season','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}


  updateSeasonFieldBaseDetails(detailId:number, seasonFieldBaseDto:SeasonFieldBaseDto ): Observable<any> {
 
    return this.httpClient.put<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/${detailId}`, seasonFieldBaseDto)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Updating Base Details','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}

updateFieldNameAllowNotification(fieldId: number, name?:string, allowNotifications?:boolean): Observable<any> {
    const body = { 
        name: name,
        allowNotifications: allowNotifications ? true : false, 
    };
    return this.httpClient.put<any>(this.API_SEASON_MANAGEMENT_URL +`/detail/field/${fieldId}`, body)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Updating base details','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}


//  DELETE ///
deleteSeasonById(id: number): Observable<any> {
  return this.httpClient.delete(this.API_SEASON_MANAGEMENT_URL + `/season/${id} `)
      .pipe(
          catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Removing  Season ','close', {
                  duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
          })
      );
}

deleteSeasonDetail(fieldId:number, seasonId:number): Observable<any> {

    const seasonBody = {
        fieldId: fieldId,
        seasonId: seasonId,
    }

    return this.httpClient.delete(this.API_SEASON_MANAGEMENT_URL + `/detail`,{ body: seasonBody })
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Removing  Field / Updating Season ','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
  }

  addDefinition(seasonId: number, fieldId: number, sourceData?: any): Observable<any> {
    const body: any = { seasonId, fieldId };
    if (sourceData) {
      if (sourceData.id) body.sourceDefinitionId = sourceData.id;
      if (sourceData.fieldType) body.fieldTypeId = sourceData.fieldType;
      if (sourceData.currentCrop) body.currentCropId = sourceData.currentCrop;
      if (sourceData.cultivar) body.cultivar = sourceData.cultivar;
      if (sourceData.plantDate) body.plantDate = sourceData.plantDate;
      if (sourceData.yieldAverage) body.yieldAverage = sourceData.yieldAverage;
      if (sourceData.yieldGoal) body.yieldGoal = sourceData.yieldGoal;
      if (sourceData.expectedWaterAmount) body.expectedWaterAmount = sourceData.expectedWaterAmount;
      if (sourceData.irrigationType) body.irrigationTypeId = sourceData.irrigationType;
      if (sourceData.isIrrigation != null) body.isIrrigation = sourceData.isIrrigation;
      if (sourceData.isHarvested != null) body.isHarvested = sourceData.isHarvested;
    }
    return this.httpClient.post<any>(this.API_SEASON_MANAGEMENT_URL + `/detail/add-definition`, body)
        .pipe(
            catchError((err) => {
                this.snackBar.open('Error adding definition', 'close', { duration: 5000 });
                return this.errorHandler(err);
            })
        );
  }

  deleteDefinition(definitionId: number): Observable<any> {
    return this.httpClient.delete<any>(this.API_SEASON_MANAGEMENT_URL + `/detail/definition/${definitionId}`)
        .pipe(
            catchError((err) => {
                this.snackBar.open('Error deleting definition', 'close', { duration: 5000 });
                return this.errorHandler(err);
            })
        );
  }

}
